import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=3edf8144&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=3edf8144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edf8144",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3edf8144')) {
      api.createRecord('3edf8144', component.options)
    } else {
      api.reload('3edf8144', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=3edf8144&scoped=true&", function () {
      api.rerender('3edf8144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mtGsiPAh5fBw/JS/comp/DateRangeExt.vue"
export default component.exports